import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


import { Link } from 'react-router-dom';
import Select from 'react-select';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

// Tabs
class ContractsSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      only_active: true,
      aircraft_id: null,
      client_id: null,
      type: null,
      payment_type: null,
      base_id: null,
      xml: 2,
      noturno: 2,
      carga_externa: 2,
      comissarios: 2,
      charter: 2,
      contract_backup_id: null,
      aircrafts_select: [],
      bases_select: [],
      clients_full_select: [],
      active_select: [
        {value: true, label: 'Sim'},
        {value: false, label: 'Não'},
      ],
      options_select: [
        {value: 2, label: 'Todos'},
        {value: 0, label: 'Não'},
        {value: 1, label: 'Sim'},
      ],
      clients_full_select: [],
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.spanLabel = this.spanLabel.bind(this);
    this.downloadXls = this.downloadXls.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            aircrafts_select: responseJson.data.aircrafts_select,
            bases_select: responseJson.data.bases_select,
            clients_full_select: responseJson.data.clients_full_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  search (event) {
    event.preventDefault()
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      only_active: this.state.only_active,
      aircraft_id: this.state.aircraft_id,
      client_id: this.state.client_id,
      type: this.state.type,
      payment_type: this.state.payment_type,
      base_id: this.state.base_id,
      xml: this.state.xml,
      noturno: this.state.noturno,
      carga_externa: this.state.carga_externa,
      comissarios: this.state.comissarios,
      charter: this.state.charter,
      contract_backup_id: this.state.contract_backup_id,
    };

    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contratos/consulta/completa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
        self.setState({overlay: {message: '', type: '', status: 'closed'}});

      });
    });
  }

  downloadXls () {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      only_active: this.state.only_active,
      aircraft_id: this.state.aircraft_id,
      client_id: this.state.client_id,
      type: this.state.type,
      payment_type: this.state.payment_type,
      base_id: this.state.base_id,
      xml: this.state.xml,
      noturno: this.state.noturno,
      carga_externa: this.state.carga_externa,
      comissarios: this.state.comissarios,
      charter: this.state.charter,
      contract_backup_id: this.state.contract_backup_id,
    };

    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contratos/consulta/xls', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.setState({overlay: {message: '', type: '', status: 'closed'}});

      });
    });
  }


  spanLabel (cell, row) {
    var botao = cell ? <span className="label label-success">{this.locale.general.sim}</span> :  <span className="label label-danger">{this.locale.general.nao}</span>;

    return botao;
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Contratos.ConsultarContrato.titulo}</h3>
      <Link to="/contratos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr />
      <h4>{this.locale.Contratos.ConsultarContrato.adicionarExcecao}</h4>
      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.SomenteAtivos}:</label>
            <Select
              className="form-field-name"
              name="only_active"
              value={this.state.only_active}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'only_active')}
              options={this.state.active_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.Aeronave}:</label>
            <Select
              className="form-field-name"
              name="aircraft_id"
              value={this.state.aircraft_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
              options={this.state.aircrafts_select}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.Cliente}:</label>
            <Select
              className="form-field-name"
              name="client_id"
              value={this.state.client_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'client_id')}
              options={this.state.clients_full_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.TipoDeTripulacao}:</label>
            <Select
              className="form-field-name"
              name="type"
              value={this.state.type}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'type')}
              options={[
                {value: "normal", label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipo.TripulacaoRegular},
                {value: "noturno", label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipo.TripulacaoNoturna},
                {value: "medvac", label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipo.TripulacaoMEDVAC},
                {value: "normal_comissarios", label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipo.TripulacaoRegularComComissarios},
                {value: "noturno_comissarios", label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipo.TripulacaoNoturnaComComissarios},
                {value: "medvac_comissarios", label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipo.TripulacaoMEDVACComComissarios},
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.TipoDePagamento}:</label>
            <Select
              className="form-field-name"
              name="payment_type"
              value={this.state.payment_type}
              searchable={true}
              placeholder={'Tipo de pagamento'}
              onChange={this.handleSelectChange.bind(this, 'payment_type')}
              options={[
                {value: 'Partida ao Corte', label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipoDePagamento.PartidaAoCorte},
                {value: 'Decolagem ao Pouso', label: this.locale.Contratos.ConsultarContrato.formulario.opcoesTipoDePagamento.DecolagemAoPouso}
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.BaseContratual}:</label>
            <Select
              className="form-field-name"
              name="base_id"
              value={this.state.base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_id')}
              options={this.state.bases_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.XML}:</label>
            <Select
              className="form-field-name"
              name="xml"
              value={this.state.xml}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'xml')}
              options={this.state.options_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.Noturno}:</label>
            <Select
              className="form-field-name"
              name="noturno"
              value={this.state.noturno}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'noturno')}
              options={this.state.options_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.CargaExterna}:</label>
            <Select
              className="form-field-name"
              name="carga_externa"
              value={this.state.carga_externa}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'carga_externa')}
              options={this.state.options_select}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.Comissarios}:</label>
            <Select
              className="form-field-name"
              name="comissarios"
              value={this.state.comissarios}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'comissarios')}
              options={this.state.options_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.Fretamento}:</label>
            <Select
              className="form-field-name"
              name="charter"
              value={this.state.charter}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'charter')}
              options={this.state.options_select}
              required
            />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.Contratos.ConsultarContrato.formulario.AeronaveBackup}:</label>
            <Select
              className="form-field-name"
              name="contract_backup_id"
              value={this.state.contract_backup_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'contract_backup_id')}
              options={this.state.aircrafts_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.consulta}</button>
          </div>
          <div className="col-md-6">
            <button type="button" onClick={() => this.downloadXls()} className="btn btn-success btn-inline btn-lg btn-block"><i className="fa fa-fw fa-file-excel-o"></i> {this.locale.Contratos.ConsultarContrato.formulario.botaoDownloadXLS}</button>
          </div>
        </div>
      </form>
      <hr />
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{noDataText: 'Nenhum contrato encontrato'}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Contratos.ConsultarContrato.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="active" dataFormat={this.spanLabel} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='85'>{this.locale.Contratos.ConsultarContrato.tabela.Ativo}</TableHeaderColumn>
        <TableHeaderColumn dataField="client_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.Cliente}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.Frota}</TableHeaderColumn>
        <TableHeaderColumn dataField="type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Contratos.ConsultarContrato.tabela.TipoDeTripulacao}</TableHeaderColumn>
        <TableHeaderColumn dataField="number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='160'>{this.locale.Contratos.ConsultarContrato.tabela.NumDeContrato}</TableHeaderColumn>
        <TableHeaderColumn dataField="management" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.Gerencia}</TableHeaderColumn>
        <TableHeaderColumn dataField="age_filter" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Contratos.ConsultarContrato.tabela.IdadeMin}</TableHeaderColumn>
        <TableHeaderColumn dataField="age_filter_maximum" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Contratos.ConsultarContrato.tabela.IdadeMax}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Contratos.ConsultarContrato.tabela.Inicio}</TableHeaderColumn>
        <TableHeaderColumn dataField="expire_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Contratos.ConsultarContrato.tabela.Termino}</TableHeaderColumn>
        <TableHeaderColumn dataField="due_date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Contratos.ConsultarContrato.tabela.DiaFixoDeVencimento}</TableHeaderColumn>
        <TableHeaderColumn dataField="payment_type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Contratos.ConsultarContrato.tabela.TipoDePagamento}</TableHeaderColumn>
        <TableHeaderColumn dataField="consumption" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Contratos.ConsultarContrato.tabela.Consumo}</TableHeaderColumn>
        <TableHeaderColumn dataField="availability" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.TempoDeDisponibilidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="availability_time" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.HoraInicialDaDisponibilidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="base_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='130'>{this.locale.Contratos.ConsultarContrato.tabela.BaseContratual}</TableHeaderColumn>
        <TableHeaderColumn dataField="xml" dataFormat={this.spanLabel} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Contratos.ConsultarContrato.tabela.XML}</TableHeaderColumn>
        <TableHeaderColumn dataField="noturno" dataFormat={this.spanLabel} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Contratos.ConsultarContrato.tabela.Noturno}</TableHeaderColumn>
        <TableHeaderColumn dataField="carga_externa" dataFormat={this.spanLabel} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Contratos.ConsultarContrato.tabela.CargaExterna}</TableHeaderColumn>
        <TableHeaderColumn dataField="comissarios" dataFormat={this.spanLabel} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Contratos.ConsultarContrato.tabela.Comissarios}</TableHeaderColumn>
        <TableHeaderColumn dataField="charter" dataFormat={this.spanLabel} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.Contratos.ConsultarContrato.tabela.Fretamento}</TableHeaderColumn>
        <TableHeaderColumn dataField="backups" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Contratos.ConsultarContrato.tabela.Backups}</TableHeaderColumn>
        <TableHeaderColumn dataField="exceptions" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='1000'>{this.locale.Contratos.ConsultarContrato.tabela.Excecoes}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default ContractsSearch;



// WEBPACK FOOTER //
// ./src/Components/Contracts/ContractsSearch.js